module.exports = __webpack_public_path__ + "media/stylesheets/images/icon/chrome_icon-bdf783f50bc49fe0578f265f6c524206.svg";